import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Observable } from 'rxjs';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { Company } from '../../model/company';
import { Property } from '../../model/property';
import { catchError, finalize, map } from 'rxjs/operators';
import { RentalObjectType } from '../../model/rental-object-type';
import { VacantParking } from '../../model/vacant-parking';
import { LocalDate } from '../../../core/model/local-date';

@Injectable()
export class VacantParkingService extends DataService<VacantParking> {
  private readonly _defaultFilterFields: string[] = [
    'company',
    'property',
    'rentalObjectType',
    'street',
    'rentalId',
    'vacantPeriod',
    'blockedRentalObjects',
    'displayType',
  ];

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, VacantParking, progressBar, 'vacant-parking');
  }

  getFilterDefinition(): Observable<{
    company: string[];
    companies: Company[];
    property: string[];
    properties: Property[];
    rentalObjectType: string;
    rentalObjectTypes: RentalObjectType[];
    street: string;
    city: string;
    rentalId: string;
    vacantPeriod: number;
    blockedRentalObjects: number;
    displayType: number;
    lettingStatus: number;
    selectedFields: string[];
    defaultFields: string[];
    vacantOnDate: LocalDate;
  }> {
    return this.client.get<any>(`${this.endpoint}/filter`).pipe(
      map(res => {
        return {
          company: Array.isArray(res.company) ? res.company : res.company ? [res.company] : [],
          companies: Array.isArray(res.companies) ? res.companies.map(x => Object.assign(new Company(), x)) : [],
          property: Array.isArray(res.property) ? res.property : res.property ? [res.property] : [],
          properties: Array.isArray(res.properties) ? res.properties.map(x => Object.assign(new Property(), x)) : [],
          rentalObjectType: res.rentalObjectType ? res.rentalObjectType : '',
          rentalObjectTypes: Array.isArray(res.rentalObjectTypes)
            ? res.rentalObjectTypes.map(x => Object.assign(new RentalObjectType(), x))
            : [],
          street: res.street ? res.street : '',
          city: res.city ? res.city : '',
          rentalId: res.rentalId ? res.rentalId : '',
          vacantPeriod: Number.isInteger(res.vacantPeriod) ? res.vacantPeriod : 0,
          lettingStatus: Number.isInteger(res.lettingStatus) ? res.lettingStatus : null,
          blockedRentalObjects: Number.isInteger(res.blockedRentalObjects) ? res.blockedRentalObjects : 0,
          displayType: Number.isInteger(res.displayType) ? res.displayType : 0,
          selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._defaultFilterFields,
          defaultFields: this._defaultFilterFields,
          vacantOnDate: res.vacantOnDate,
        };
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  getVacancyOverview(filter: any): Observable<any[]> {
    filter = this.prepareFilter(filter);
    this.progressBar.start();
    return this.client
      .post<any[]>(`${this.endpoint}/vacancy-overview`, JSON.stringify(filter), { headers: { 'Content-Type': 'application/json' } })
      .pipe(
        catchError(error => {
          this.notification.showError(error);
          return [];
        }),
        finalize(() => this.progressBar.stop())
      );
  }

  export(ids: string[]): Observable<File> {
    return super.exportDataItems(ids, 'Lediga hyresobjekt bilplatser.xlsx');
  }
}
